import { PreviousRouteService } from './../../../../../shared/src/lib/service/previous-route.service';
import { ExerciceSheetService } from './../../../../../shared/src/lib/service/exerciceSheet.service';
import { ExerciceService } from './../../../../../shared/src/lib/service/exercice.service';
import { ExerciceQuestionService } from './../../../../../shared/src/lib/service/exerciceQuestion.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ExerciceSheet } from '../../../../../shared/src/lib/model/exerciceSheet.model';
import { Exercice } from '../../../../../shared/src/lib/model/exercice.model';
import { ExerciceList } from '../../../../../shared/src/lib/model/exerciceList.model';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-sheet-detail',
  templateUrl: './sheet-detail.component.html',
  styleUrls: ['./sheet-detail.component.scss']
})
export class SheetDetailComponent implements OnInit {
  sheet: ExerciceSheet = null;
  previousUrl;
  
  // Gestion des exercices
  exercises: Exercice[] = [];
  exercisesData: ExerciceList;
  showExercisePreviewMap = new Map<number, boolean>();
  exerciseDetailsMap = new Map<number, Exercice>();
  // Stockage de l'état de chargement
  exercisesLoading = false;
  exercisesLoadMoreLoading = false;
  exerciseQuestionsLoadingMap = new Map<number, boolean>();
  
  constructor(
    private route: ActivatedRoute,
    private exerciceSheetService: ExerciceSheetService,
    private exerciceService: ExerciceService,
    private exerciceQuestionService: ExerciceQuestionService,
    private previousRouteService: PreviousRouteService,
  ) { }

  ngOnInit() {
    const sheetId = this.route.snapshot.params.id;
    this.getSheet(sheetId);
    this.previousUrl = this.previousRouteService.getPreviousUrl();
  }

  getSheet(sheetId) {
    this.exerciceSheetService.getExerciceSheetById(sheetId).subscribe(data => {
      if (data) {
        this.sheet = data;
        // Charger les exercices de la fiche
        this.loadExercises(sheetId);
      }
    })
  }
  
  /** Charger les exercices liés à cette fiche */
  loadExercises(sheetId: number) {
    this.exercisesLoading = true;
    
    const params = new HttpParams()
      .set('sheets', sheetId.toString())
      .set('page_size', '15')
      .set('salt', Math.random().toString());
    
    this.exerciceService.getExercices(params).subscribe({
      next: (data) => {
        if (data) {
          this.exercisesData = data;
          this.exercises = data.results;
        }
        this.exercisesLoading = false;
      },
      error: () => {
        this.exercisesLoading = false;
      }
    });
  }
  
  /** Charger plus d'exercices (pagination) */
  loadMoreExercises() {
    if (this.exercisesData?.next) {
      this.exercisesLoadMoreLoading = true;
      
      this.exerciceService.getExercicesByUrl(this.exercisesData.next).subscribe({
        next: (data) => {
          if (data) {
            this.exercises = [...this.exercises, ...data.results];
            this.exercisesData = data;
          }
          this.exercisesLoadMoreLoading = false;
        },
        error: () => {
          this.exercisesLoadMoreLoading = false;
        }
      });
    }
  }
  
  /** Afficher/Masquer la prévisualisation d'un exercice */
  toggleExercisePreview(exerciseId: number) {
    const isCurrentlyVisible = this.showExercisePreviewMap.get(exerciseId);
    
    if (!isCurrentlyVisible && !this.exerciseDetailsMap.has(exerciseId)) {
      this.loadExerciseDetails(exerciseId);
    }
    
    this.showExercisePreviewMap.set(exerciseId, !isCurrentlyVisible);
  }
  
  /** Charger les détails d'un exercice avec ses questions */
  private loadExerciseDetails(exerciseId: number) {
    // Activer le loader
    this.exerciseQuestionsLoadingMap.set(exerciseId, true);
    
    this.exerciceService.getExerciceById(exerciseId).subscribe(exercice => {
      if (exercice) {
        const params = new HttpParams()
          .set('exercice', exerciseId.toString())
          .set('page_size', '100')
          .set('salt', Math.random().toString());
        
        this.exerciceQuestionService.getExerciceQuestions(params).subscribe({
          next: (questionsData) => {
            if (questionsData && questionsData.results) {
              exercice.questions = questionsData.results;
            }
            this.exerciseDetailsMap.set(exerciseId, exercice);
            // Désactiver le loader
            this.exerciseQuestionsLoadingMap.set(exerciseId, false);
          },
          error: () => {
            // Désactiver le loader en cas d'erreur
            this.exerciseQuestionsLoadingMap.set(exerciseId, false);
          }
        });
      } else {
        this.exerciseQuestionsLoadingMap.set(exerciseId, false);
      }
    });
  }
  
  /** Vérifier si la prévisualisation d'un exercice est visible */
  isExercisePreviewVisible(exerciseId: number): boolean {
    return this.showExercisePreviewMap.get(exerciseId) ?? false;
  }
  
  /** Récupérer les détails d'un exercice */
  getExerciseDetails(exerciseId: number): Exercice | undefined {
    return this.exerciseDetailsMap.get(exerciseId);
  }
  
  /** Indique si les questions d'un exercice sont en cours de chargement */
  isExerciseQuestionsLoading(exerciseId: number): boolean {
    return this.exerciseQuestionsLoadingMap.get(exerciseId) ?? false;
  }
}
